import { Attachment, FilePresent } from '@mui/icons-material'
import Close from '@mui/icons-material/Close'
import { Drawer, Grid, Typography } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import { Button, IconButton, Table, TableProvider, Tooltip } from 'components'
import Tracking from 'modules/orders/components/Tracking/Tracking'
import { useTrackingModalStore } from 'modules/orders/components/Tracking/trackingModalStore'
import { useLoadOrderTrackings } from 'modules/orders/hooks'
import { Order } from 'modules/orders/types'
import { useState } from 'react'
import { HiPlus } from 'react-icons/hi'
import { useParams } from 'react-router-dom'
import { formatDate, getUrlSearchParam } from 'utils'
import { RenderCellExpand } from './RenderExpandedCell'

export const Trackings = ({ order }: { order?: Order }) => {
  const { id } = useParams()
  const { data: trackings } = useLoadOrderTrackings(id)

  const [open, setOpen] = useState(false)
  const [selectedAttachment, setSelectedAttachment] = useState<any>({})

  const isTrackingOpen = useTrackingModalStore.useIsModalOpen()
  const setModalOpen = useTrackingModalStore.useSetModalOpen()
  const setData = useTrackingModalStore.useSetData()

  const columns: GridColDef[] = [
    {
      field: 'subject',
      headerName: 'Assunto',
      width: 300
    },
    {
      field: 'text',
      headerName: 'Texto',
      flex: 1,
      renderCell: RenderCellExpand
    },
    // {
    //   field: 'dateHeld',
    //   headerName: 'Dt. de Entrega Realizada',
    //   width: 200,
    //   renderCell: (row: any) => formatDate(row?.value)
    // },
    // {
    //   field: 'datePlanned',
    //   headerName: 'Dt. de Entrega Prevista',
    //   width: 200,
    //   renderCell: (row: any) => formatDate(row?.value)
    // },
    {
      field: 'action',
      headerName: 'Anexo',
      headerAlign: 'center',
      align: 'center',
      renderCell: (row: any) => {
        const a = row?.row?.attachments?.map((attach: any) =>
          getUrlSearchParam(attach, 'fileId')
        )

        if (!a?.some((item: any) => item)) return null

        return (
          <IconButton
            onClick={() => {
              setSelectedAttachment(row?.row)
              setOpen(true)
            }}
          >
            <FilePresent />
          </IconButton>
        )
      }
    },
    {
      field: 'date',
      headerName: 'Data',
      width: 180,
      renderCell: (row: any) => formatDate(row.row.date, 'dd/MM/yyyy HH:mm:ss')
    }
  ]

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 200px)'
      }}
    >
      <Grid container spacing={2} sx={{ flexShrink: 0, marginBottom: 1 }}>
        <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
          <Button
            startIcon={<HiPlus size={18} />}
            onClick={() => {
              setData({
                orderId: id || '',
                customerId: order?.customer.id || ''
              })
              setModalOpen(true)
            }}
            size="small"
          >
            Acompanhamento
          </Button>
        </Grid>
      </Grid>
      {isTrackingOpen && <Tracking />}
      <div style={{ flex: 1, minHeight: 0 }}>
        <TableProvider>
          <Table
            columns={columns}
            rows={trackings?.data}
            getRowId={(row: any) => row?.id}
          />
        </TableProvider>
      </div>
      <Drawer anchor="right" open={open} onClose={setOpen}>
        <div
          style={{
            top: 0,
            backgroundColor: 'white',
            padding: 15,
            maxWidth: 450
          }}
        >
          <Grid
            container
            item
            alignItems="center"
            justifyContent={'space-between'}
            xs={12}
          >
            <Grid item>
              <Typography variant="h6">Arquivos Anexados</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => setOpen(false)}>
                <Close
                  style={{ background: '', color: '#565656', fontSize: 24 }}
                />
              </IconButton>
            </Grid>
          </Grid>
          {selectedAttachment?.attachments?.map((attach: any) => {
            const fileId = getUrlSearchParam(attach, 'fileId')

            const attachment = Buffer.from(fileId || '', 'base64').toString(
              'ascii'
            )

            const formattedAttachment = attachment.split('/')
            const formattedAttachmentLen = formattedAttachment.length
            const file = formattedAttachment[formattedAttachmentLen - 1]

            return (
              <div
                key={attachment}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginBottom: 15,
                  marginTop: 20
                }}
              >
                <Attachment />
                <Typography
                  variant="body1"
                  ml={1}
                  sx={{
                    width: 300,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <Tooltip title={`${file}`}>
                    <a
                      href={attach}
                      target="__blank"
                      download={`${file}`}
                      style={{ textDecoration: 'none', color: '#0C95EB' }}
                    >
                      {`${file}`}
                    </a>
                  </Tooltip>
                </Typography>
              </div>
            )
          })}
        </div>
      </Drawer>
    </div>
  )
}
